import React, { useEffect, useState } from 'react';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { useParams } from 'react-router-dom';
import ClientGallery from './components/ClientGallery';
import SectionTopMenu from '../../shared/components/SectionTopMenu/SectionTopMenu';

const Client = () => {
  const { clientId } = useParams();
  const currentClient = useStoreState(state => state.currentClient);
  const setCurrentClient = useStoreActions(actions => actions.setCurrentClient);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setCurrentClient(clientId);
    setIsLoading(false);
  }, []);

  return isLoading ? null : (
    <div>
      <SectionTopMenu clientName={currentClient.name} />
      <ClientGallery />
    </div>
  );
};

export default Client;
